import useAsyncData from "../../../../hooks/use-async-data";
import orderService from "../../order.service";
import OrderCargoOrderDetails from "./order-cargo-order-details";
import OrderCargoOrderDetailsParams from "./order-cargo-order-details-params";

const useOrderCargoOrderDetails = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<OrderCargoOrderDetails | null>(null);

  const load = async (
    params: OrderCargoOrderDetailsParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const cargoOrderDetails = await orderService.getDetails(params, signal);

      setData(cargoOrderDetails);
      setIsLoading(false);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useOrderCargoOrderDetails;
